import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import InternalLayout from "../pages/InternalLayout.vue";
import LandingPage from "../pages/LandingPage.vue";
import InfoPage from "../pages/InfoPage.vue";

const routes: RouteRecordRaw[] = [
  {
    path: "/",
    name: "landing",
    component: LandingPage,
    alias: "/landing",
  },
  {
    path: "/app",
    name: "app",
    component: InternalLayout,
  },
  {
    path: "/info",
    name: "info",
    component: InfoPage,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
